import React from 'react';

import { FlatList } from '@rbilabs/universal-components';

import { MappedOrder } from '../types';

import { MenuReorderItemsListItem } from './menu-reorder-items-list-item';

export const MenuReorderItemsList = ({
  orderEntries,
  ListHeaderComponent,
}: {
  orderEntries: MappedOrder['orderEntries'];
  ListHeaderComponent: React.ComponentType<any>;
}) => (
  <FlatList
    data={orderEntries}
    renderItem={({ item }) => <MenuReorderItemsListItem item={item} />}
    keyExtractor={item => item.sanityId}
    ListHeaderComponent={ListHeaderComponent}
    stickyHeaderIndices={[0]}
    style={{ width: '100%' }}
  />
);
